import { collection, addDoc, serverTimestamp, getDocs, query } from "firebase/firestore";
import { db } from "../firebase";
import { localPosts } from "../data/blogData";

function convertToHtml(post) {
  let html = "";

  if (post.content.intro) {
    html += `<p>${post.content.intro}</p>`;
  }

  if (post.content.sections && post.content.sections.length > 0) {
    post.content.sections.forEach((section) => {
      html += `<h2>${section.heading}</h2>`;
      html += `<p>${section.body}</p>`;
    });
  }

  return html;
}

function inferTags(post) {
  const tags = [];
  const text = `${post.title} ${post.excerpt} ${post.content.intro} ${
    post.content.sections
      ? post.content.sections.map((s) => `${s.heading} ${s.body}`).join(" ")
      : ""
  }`.toLowerCase();

  const tagPatterns = [
    { tag: "security", patterns: ["security", "secure", "firewall", "cyber", "attack", "breach", "ransomware", "phishing"] },
    { tag: "networking", patterns: ["network", "vlan", "ospf", "router", "switch", "lan", "wan", "tcp", "ip"] },
    { tag: "monitoring", patterns: ["monitor", "siem", "wazuh", "alert", "logging", "observability"] },
    { tag: "cctv", patterns: ["cctv", "camera", "surveillance", "nvr", "video"] },
    { tag: "infrastructure", patterns: ["infrastructure", "server", "datacenter", "cloud", "isp", "fiber", "gpon"] },
    { tag: "software", patterns: ["software", "development", "react", "next.js", "python", "database", "devops", "ci/cd", "github actions"] },
    { tag: "automation", patterns: ["automat", "ansible", "python", "script"] },
    { tag: "web-design", patterns: ["web design", "digital transformation", "container cabin", "spatial planning"] },
    { tag: "best-practices", patterns: ["best practice", "guideline", "recommendation", "implementation"] },
    { tag: "enterprise", patterns: ["enterprise", "corporate", "business", "office"] },
  ];

  tagPatterns.forEach(({ tag, patterns }) => {
    if (patterns.some((p) => text.includes(p))) {
      tags.push(tag);
    }
  });

  return tags;
}

function estimateReadingTime(htmlContent) {
  const text = htmlContent.replace(/<[^>]*>/g, "");
  const words = text.split(/\s+/).filter(Boolean).length;
  const minutes = Math.max(1, Math.ceil(words / 200));
  return `${minutes} min read`;
}

export async function migratePosts(onProgress) {
  const postsCollection = collection(db, "posts");
  const existingQuery = query(postsCollection);
  const existingSnapshot = await getDocs(existingQuery);

  if (existingSnapshot.docs.length > 0) {
    const proceed = window.confirm(
      `There are already ${existingSnapshot.docs.length} posts in Firestore. Do you want to add the ${localPosts.length} local posts anyway?`
    );
    if (!proceed) return { migrated: 0, skipped: localPosts.length };
  }

  let migrated = 0;
  let skipped = 0;

  for (let i = 0; i < localPosts.length; i++) {
    const post = localPosts[i];
    const content = convertToHtml(post);
    const tags = inferTags(post);
    const readingTime = estimateReadingTime(content);

    try {
      await addDoc(postsCollection, {
        slug: post.slug,
        title: post.title,
        excerpt: post.excerpt,
        content: content,
        category: post.category,
        tags: tags,
        author: post.author,
        date: post.date,
        readingTime: readingTime,
        image: post.image,
        published: true,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
      migrated++;
      if (onProgress) onProgress(i + 1, localPosts.length, post.title);
    } catch (err) {
      console.error(`Failed to migrate "${post.title}":`, err);
      skipped++;
    }
  }

  return { migrated, skipped };
}
